import { HTMLAttributes } from 'react'
import { cva, VariantProps } from 'class-variance-authority'
import { cn } from '@utils/tailwind.utils.ts'

export const containerVariants = cva('mx-auto pb-10', {
  variants: {
    size: {
      sm: 'max-w-container-md xs:px-10',
      md: 'max-w-container-lg px-4 xs:px-4',
      mid: 'max-w-[60rem] px-4 xs:px-10',
      full: 'max-w-container-xl mx-0 max-w-full',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export type ContainerProps = VariantProps<typeof containerVariants> &
  HTMLAttributes<HTMLDivElement>

export function Container({ className, size = 'md', children }: ContainerProps) {
  return <div className={cn(containerVariants({ className, size }))}>{children}</div>
}
